import { createFileRoute } from "@tanstack/react-router";
import { LocationDetail } from "../components/network/location-detail.tsx";

/** `/natverk/plats/:franchiseId` — the drill-down behind a map pin or a league-table row. */
export const Route = createFileRoute("/natverk/plats/$franchiseId")({ component: Screen });

function Screen() {
  const { franchiseId } = Route.useParams();
  return <LocationDetail franchiseId={franchiseId} />;
}
